import { Component, inject, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { NlToBrPipe } from '../../../../../../../pipes/nl-to-br.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-p00058-en-savoir-plus',
  templateUrl: './p00058-en-savoir-plus.component.html',
  styleUrls: ['./p00058-en-savoir-plus.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    NlToBrPipe,
    TranslatePipe,
  ],
})
export class P00058EnSavoirPlusComponent {
  private modalController: ModalController = inject(ModalController);

  constructor() {}

  async dismissModal() {
    await this.modalController.dismiss();
  }
}
